module.exports = {
	"default": {
		"title": "Geogaming",
		"logo": "/static/img/menu/logo/geogaming.jpg",
		"introText": "This is a <strong>fun geocaching game </strong>where you walk around to discover challenge locations, and <strong>answer questions</strong> as fast as possible with your team!"
	},
	"dev": {
		"title": "Geogaming DEV",
		"logo": "/static/img/menu/logo/dev.jpg",
		"introText": "[dev] \"We are so happy you are trying Geogaming.<br/>We hope you’ll love it. Remember this is a demo version, (almost) <strong>everything is customisable</strong><br/>Support: <a href='mailto:info@geogaming.io'>info@geogaming.io</a>"
	},
	"demo": {
		"title": "Geogaming DEMO",
		"logo": "/static/img/menu/logo/demo.jpg",
		"introText": "We are so happy you are trying Geogaming.<br/>We hope you’ll love it. Remember this is a demo version, (almost) <strong>everything is customisable</strong><br/>Support: <a href='mailto:info@geogaming.io'>info@geogaming.io</a>"
	},
	"elpro": {
		"title": "ELpro",
		"logo": "/static/img/menu/logo/elpro.jpg"
	},
	"prod": {
		"title": "Corporate Challenge",
		"logo": "/static/img/menu/logo/prod.jpg"
	},
	"play": {
		"title": "Corporate Challenge",
		"logo": "/static/img/menu/logo/prod.jpg"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/geogaming-config.json
// module id = 171
// module chunks = 1